module.exports = "./img/1a25c080e26dfab1bd4878e1bb4cd7a4.jpg";